import type { PagedRequestDto } from '../pagination/models';

export interface ServiceTypeDto {
  id: number;
  name: string;
}

export interface ServiceTypeInputDto {
  id: number;
  name: string;
}

export interface ServiceTypePagedRequestDto extends PagedRequestDto {
  name?: string;
}
